import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = {amounts: [], total: ''}

const state = {
  addressTypes: startState
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.addressTypes = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.addressTypes = startState
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.addressTypes
}

export const AddressTypes = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/barCharts/AddressTypes.js